const initForm = {
  name: null,
  email: null,
  phone: null,
  pickupVendor: null,
  address: null
}

export default function () {
  return {
    filterResponse: {},
    selectedRow: [],
    fetchedData: null,

    variantType: {
      value: null
    },

    formDefault: JSON.parse(JSON.stringify(initForm)),
    form: { ...initForm }
  }
}
